<template>
  <div class="preview-modal">
    <el-button type="success" icon="el-icon-view" @click="dialogVisible = true">{{ $t('common.view') }}</el-button>
    <el-dialog
        title="Preview File"
        :visible.sync="dialogVisible" fullscreen>
      <el-button @click="dialogVisible = false" class="icon-close" size="mini" icon="el-icon-close" circle ></el-button>
      <el-row>
        <el-col :span="24">
          <div v-if="typeFile !== 'pdf'">
            <VueDocPreview v-if="typeFile=== 'office'" class="content-preview" :value="fileUrl" type="office" />
<!--            <iframe v-if="typeFile=== 'office'" class="content-preview" :src="fileUrl ? `https://docs.google.com/gview?url=${fileUrl}&embedded=true`: ''"></iframe>-->
            <div v-if="typeFile==='txt'">
              <iframe  :src="fileUrl" class="content-preview" ></iframe>
            </div>
            <img v-if="typeFile==='image'" class="image-preview"  :src="fileUrl" alt="">
            <div v-if="typeFile==='order'" class="not-preview">
              アプリケーションは現在、このファイル形式を開くことをサポートしていません
            </div>
          </div>
          <div v-else>
            <object class="content-preview" :data="fileUrl" type="application/pdf" ></object>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import VueDocPreview from 'vue-doc-preview'
import {checkTypeFile} from '../utils/index'
export default {
  props: ['fileUrl'],
  components:{
    VueDocPreview
  },
  data(){
    return{
      dialogVisible: false
    }
  },
  computed:{
    typeFile(){
      let typeFile = checkTypeFile(this.fileUrl) || null
      return typeFile
    }
  }
}
</script>
<style lang="scss">
.image-preview{
  width: 80%;
  height: auto;
  margin-top:2rem;
}
.content-preview{
  width: 100%;
  height: 100vh;
}
.preview-modal{
  display: inline;
  .el-dialog{
    border-radius: 6px;
    &__header {
      padding: .8rem 0;
      background: #213F9A;
      display: none;
    }
    &__headerbtn{
      //display: none;
      top:15px;
      color: #fff;
      i{
        font-weight: bold;
      }
    }
    &__title{
      color: #fff;
    }
    &__body{
      padding:0 !important
    }
  }

  .w-100{
    width: 100%;
  }
  .form-lable{
    font-size: 14px;
  }
  .icon-close{
    font-weight: bold;
    position: absolute;
    top:12px;
    right:15px;
    z-index:999;
    cursor: pointer;
  }
}
</style>
